import { BarElement, CategoryScale, Chart, LinearScale } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Bar } from 'react-chartjs-2';

import { TauxDistributionItem } from '@/api';

import styles from './styles.module.css';

Chart.register(BarElement, CategoryScale, LinearScale);

type Props = {
  donnees: TauxDistributionItem[] | undefined;
};

const ColumnChart = ({ donnees }: Props) => {
  const ordreDonnee = donnees?.slice().reverse();

  const data = {
    labels: ordreDonnee?.map((donneeAnRef) => donneeAnRef.anneeRef),

    datasets: [
      {
        data: ordreDonnee?.map((donneePourcent) => donneePourcent.pourcentage),

        backgroundColor: ['#77604B'],
        pointBackgroundColor: 'transparent',
        borderWidth: 1,
      },
    ],
    options: {
      scales: {
        y: {
          display: false,
          min: 0,
          grid: {
            display: false,
          },
        },

        x: {
          display: true,

          border: {
            display: false,
          },
          grid: {
            display: false,
          },
          ticks: {
            color: '#040404',
            font: {
              size: 14,
              family: 'Poppins, Arial',
            },
          },
        },
      },

      plugins: {
        legend: {
          display: false,
        },

        datalabels: {
          color: '#040404',
          anchor: 'end' as const,
          align: 'start' as const,
          offset: -20,
          font: {
            size: 14,
            family: 'Poppins, Arial',
          },

          formatter: function (value: number) {
            return value + ' %';
          },
        },
      },

      layout: {
        padding: {
          top: 15,
        },
      },

      maintainAspectRatio: false,
      responsive: true,
      events: [],
    },
  };

  return (
    <div className={styles.columnChart}>
      <Bar data={data} plugins={[ChartDataLabels]} options={data.options} />
    </div>
  );
};

export default ColumnChart;
